//Componentes generales
import React, { useContext, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import SubcuentaList from "../../components/SubcuentaList/SubcuentaList";

//Context
import subcuentasContext from "../../context/subcuentas/subcuentasContext";
import authContext from "../../context/authentication/authContex";

// Alertas
import Swal from "sweetalert2";

//Estilos
import "./Subcuenta.css";

//Iconos
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowLeft } from "@fortawesome/free-solid-svg-icons";

/* 
    Vista donde se gestiona toda la lógica de listado de subcuentas.
    Donde props no se encuentra en uso.
*/
function Subcuenta(props) {
  //Context Auth
  const aContext = useContext(authContext);
  const { usuario } = aContext;

  //Context subcuentas
  const sContext = useContext(subcuentasContext);
  const { subcuentas, actualizarSubcuentas, actualizarSubcuentasDB } =
    sContext;

  const navigate = useNavigate();

  /* 
        Disparador que se ejecuta ante la renderización del componente. El mismo se encarga de actualizar las subcuentas disponibles del context.
    */
  useEffect(() => {
    const fn = async () => {
      await actualizarSubcuentas();
    };
    fn();

  }, []);

  const handleBack = () => {
    navigate("/abms");
  };

  /* 
        Manejador que se encarga de la actualización de subcuentas que sobreescribe los subcuentas actuales por los recuperados de Softland.
    */
  const handlerActualizarSubcuentas = async () => {
    Swal.fire({
      title: "Desea actualizar la lista de subcuentas?",
      text: "Se traeran los datos de Softland para sobreescribir la base de datos de la aplicación.",
      showCancelButton: true,
      confirmButtonText: "Actualizar",
      cancelButtonText: "No, cancelar",
      showLoaderOnConfirm: true,
      preConfirm: async () => {
        return await actualizarSubcuentasDB(usuario._id, usuario.userName)
          .then((response) => {
            if (!response.status) {
              throw new Error(response.msg);
            }
            return response;
          })
          .catch((error) => {
            Swal.showValidationMessage(`Request failed: ${error}`);
          });
      },
      allowOutsideClick: () => !Swal.isLoading(),
    }).then((result) => {
      if (result.isConfirmed) {
        Swal.fire(
          "Actualizado!",
          "La base de datos ha sido actualizada correctamente.",
          "success"
        );
      }
    });
  };

  return (
    <div className="container-list">
      <div className="back-button-container">
        <button className="back-btn" onClick={handleBack}>
          <FontAwesomeIcon icon={faArrowLeft} style={{ marginRight: "5px" }} />
        </button>
      </div>
      <div className="actualiza-subcuentas-container">
        <button
          className="actualizar-subcuentas-btn"
          onClick={handlerActualizarSubcuentas}
        >
          Actualizar Subcuentas
        </button>
      </div>
      <SubcuentaList subcuentas={subcuentas} />
    </div>
  );
}

export default Subcuenta;